export default __webpack_public_path__ + "static/media/WHT-USDT.34856c92.png";